<template>
    <div class="office-jobs">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span>
                </div>
                <div class="browse-sort mx-auto mt-2">
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="Job Type" key="1">
                            <div class="text-left px-3 px-md-5">
                                <div class="">
                                    <label class="checkbox-label">
                                        <input type="checkbox" />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-4 ml-2 ctrl-size-2">Junior ($10-$20/hr)</span>
                                    </label>
                                </div>
                                <div class="pt-2">
                                    <label class="checkbox-label">
                                        <input type="checkbox" />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-4 ml-2 ctrl-size-2">Intermediate ($15-$40/hr)</span>
                                    </label>
                                </div>
                                <div class="pt-2">
                                    <label class="checkbox-label">
                                        <input type="checkbox" />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-4 ml-2 ctrl-size-2">Senior ($25-$60/hr)</span>
                                    </label>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Project Type" key="2">
                            <div class="text-left px-3 px-md-5">
                                <div class="">
                                    <label class="checkbox-label">
                                        <input type="checkbox" />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-4 ml-2 ctrl-size-2">Hourly</span>
                                    </label>
                                </div>
                                <div class="pt-2">
                                    <label class="checkbox-label">
                                        <input type="checkbox" />
                                        <span class="checkbox-custom rectangular"></span
                                        ><span class="pl-4 ml-2 ctrl-size-2">Fixed</span>
                                    </label>
                                </div>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Skill" key="3">
                            <a-select
                                mode="multiple"
                                class="w-100"
                                @change="handleChange"
                                size="large"
                                placeholder="Enter/Choose skills"
                            >
                                <a-select-option v-for="stack in stacks" :key="stack">{{
                                    stack
                                }}</a-select-option></a-select
                            >
                        </a-tab-pane>
                        <a-tab-pane tab="Price Range" key="4">
                            <div class="text-left px-3 px-md-5">
                                <a-slider
                                    range
                                    :step="10"
                                    :min="0"
                                    :max="500"
                                    :defaultValue="[20, 50]"
                                    @change="onChange"
                                    @afterChange="onAfterChange"
                                />
                                <h5 class="mt-3 ml-4 latest">${{ range[0] }} - ${{ range[1] }}</h5>
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Location" key="5">
                            <a-select class="w-100" size="large" placeholder="Please select your Country">
                                <a-select-option v-for="(item, index) in countries" :key="index">{{
                                    item.name
                                }}</a-select-option>
                            </a-select>
                        </a-tab-pane>
                        <a-tab-pane tab="Language" key="6">
                            <div class="text-left px-3 px-md-5">
                                <label class="checkbox-label mb-1">
                                    <input type="checkbox" checked />
                                    <span class="checkbox-custom rectangular"></span
                                    ><span class="pl-5 mb-3 ctrl-size-2">English</span> </label
                                ><br />
                            </div>
                        </a-tab-pane>
                        <a-tab-pane tab="Reset Filter" key="7"> </a-tab-pane>
                    </a-tabs>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div class="row browse-list mt-4 mx-auto">
                            <div class="col-6 col-md-9">
                                <a-input
                                    class="mt-4 ml-4"
                                    size="large"
                                    placeholder="Search"
                                    ref="searchInput"
                                    autofocus
                                >
                                    <a-icon slot="prefix" type="search" />
                                    <a-tooltip slot="suffix" title="Extra information">
                                        <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                                    </a-tooltip>
                                </a-input>
                            </div>
                            <div class="col-6 col-md-3">
                                <span class="sort-by ml-3"> sort by <span class="latest"> latest </span> </span>
                            </div>
                        </div>
                        <div class="mt-4 mb-5 browse-list mx-auto">
                            <div class="p-4 bg-light border shadow-sm add-rounded">
                                <div :key="work" v-for="work in workHistory">
                                    <div class="row px-3">
                                        <!-- <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                    </div> -->
                                        <div class="col-12 col-sm-12 col-md-8 text-left">
                                            <router-link to="/job-details">
                                                <h4 class="font-weight-bolder kova-text">{{ work.title }}</h4>
                                            </router-link>
                                        </div>
                                        <div
                                            class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-4 float-text"
                                        >
                                            <h5 class="font-weight-bolder kova-text">$34k - $45k/Yr</h5>
                                        </div>
                                        <div class="px-3">
                                            <p class="text-size2 text-left">{{ work.comment }}</p>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-8 text-left">
                                            <!-- <span>
                                            <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                            <span class="font-weight-light">{{work.duration}}</span>
                                        </span> -->
                                            <!-- <span class="ctrl-size text-uppercase my-0 intermediate font-weight-bolder">intermediate</span> -->
                                            <!-- <span class="ctrl-size mb-1"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark ml-4 mr-1"></font-awesome-icon>Lagos, Nigeria</span> -->

                                            <div class="row mt-2">
                                                <div class="col-6 col-sm-4">
                                                    <h6
                                                        class="font-weight-bolder ctrl-size-2 text-uppercase my-0 intermediate"
                                                    >
                                                        intermediate
                                                    </h6>
                                                    <p class="ctrl-size">Experience Level</p>
                                                </div>
                                                <div class="col-6 col-sm-4">
                                                    <h6 class="font-weight-bolder ctrl-size-2">
                                                        <font-awesome-icon
                                                            style="font-size: 14px;"
                                                            icon="map-marker-alt"
                                                            class="text-dark mr-1"
                                                        ></font-awesome-icon
                                                        >Lagos, Nigeria
                                                    </h6>
                                                    <p class="ctrl-size ml-3">Location</p>
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <h6 class="font-weight-bolder ctrl-size-2">10 - 30 hrs/week</h6>
                                                    <p class="ctrl-size">Hours needed</p>
                                                </div>
                                                <div class="col">
                                                    <h6 class="font-weight-bolder ctrl-size-2">3 - 6 Months</h6>
                                                    <p class="ctrl-size">Duration</p>
                                                </div>
                                                <div class="col">
                                                    <h6 class="font-weight-bolder ctrl-size-2">$26/hr</h6>
                                                    <p class="ctrl-size">Hourly</p>
                                                </div>
                                            </div>
                                            <p class="text-left font-weight-bolder ctrl-size mb-1">
                                                <font-awesome-icon class="ctrl-size" icon="clock" /> 30 minutes ago for
                                            </p>
                                            <p class="text-left font-weight-bolder ctrl-size my-0">
                                                <span class=" kova-green mr-2"
                                                    ><font-awesome-icon class="ctrl-size mr-2" icon="gavel" />2
                                                    bids</span
                                                ><font-awesome-icon class="ctrl-size" icon="tag" /> PHP, Website Design,
                                                Wordpress, CSS, HTML
                                            </p>
                                        </div>

                                        <div
                                            class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-4 float-text"
                                        >
                                            <div class="pt-md-3"></div>
                                            <div class="pt-0 mt-1 mt-md-5 pt-md-5 d-flex">
                                                <div class="mr-auto"></div>
                                                <button
                                                    class="btn-kovatek py-2 px-4 px-md-5 mr-3 add-rounded"
                                                    @click="devDetails"
                                                >
                                                    Apply
                                                </button>
                                                <font-awesome-icon
                                                    class="icon-size mt-1"
                                                    :style="{ color: work.color }"
                                                    :icon="[work.icon, 'bookmark']"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                                <a-pagination
                                    showQuickJumper
                                    :defaultCurrent="2"
                                    :total="500"
                                    @change="peginationChange"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-4 pl-lg-0 pt-lg-2 mt-lg-5">
                        <div class="pt-2 mt-3 ml-lg-4" style="position: sticky; top: 75px">
                            <Notifications />
                            <!-- <Messages /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import Notifications from '@/components/Notifications.vue';
// import Messages from '@/components/Messages.vue'
import countries from '../data/countries.json';
import { stacks } from '../data/resources';

export default {
    name: 'office-jobs',
    components: {
        Navbar,
        Footers,
        Notifications,
        // Messages
    },
    data() {
        return {
            countries,
            workHistory: [
                {
                    title: 'Customise Wordpress login',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    status: 'You are hired',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                    icon: 'far',
                    color: '#919191',
                },
                {
                    title: 'Wordpress login',
                    star: 5,
                    status: 'Undergoing Interview',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                    icon: 'fas',
                    color: '#fe9816',
                },
                {
                    title: 'Design sign up and user authentication',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    status: 'Undergoing Interview',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                    icon: 'far',
                    color: '#919191',
                },
                {
                    title: 'UX wireframes',
                    star: 5,
                    status: 'Lost Bid',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                    icon: 'fas',
                    color: '#fe9816',
                },
                {
                    title: 'Customise Wordpress login',
                    duration: ' Mar 2016 - Sep 2018',
                    star: 5,
                    status: 'Lost Bid',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34,
                    earnedPerHour: 20.0,
                    hours: 48,
                    icon: 'far',
                    color: '#919191',
                },
                {
                    title: 'Customise Wordpress login',
                    star: 5,
                    status: 'Lost Bid',
                    comment:
                        'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.0,
                    earnedPerHour: 30.0,
                    hours: 19,
                    icon: 'fas',
                    color: '#fe9816',
                },
            ],
            range: [],
            stacks,
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        onChange(value) {
            // console.log('change: ', value);
            this.range = value;
        },
        onAfterChange(value) {
            // console.log('afterChange: ', value);
            this.range = value;
        },
        handleChange() {},
        peginationChange() {},
        findJobs() {
            this.$router.push('office-jobs');
        },
        devDetails() {
            this.$router.push('dev-details');
        },
    },
    mounted() {
        this.$http({
            method: 'GET',
            url: 'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
            headers: {
                'x-rapidapi-host': 'ajayakv-rest-countries-v1.p.rapidapi.com',
                'x-rapidapi-key': '6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d',
            },
        }).then(response => {
            this.countries = response.data;
            // console.log(response.data)
        });
    },
};
</script>

<style scoped>
.browse-sort {
    width: 80%;
}
.sort-by {
    position: relative;
    top: 33px;
}
.icon-size {
    font-size: 30px;
}
.icon-size1 {
    font-size: 20px;
}
.img-height {
    width: 75px;
    height: 75px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 11px;
}
.ctrl-size-1 {
    font-size: 20px;
}
.ctrl-size-2 {
    font-size: 12px;
}
.latest {
    color: #2db7f5;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
    .browse-sort {
        width: 100%;
    }
}

@media screen and (max-width: 550px) {
    .ctrl-search {
        width: 55%;
    }
    .img-height {
        width: 75px;
        height: 75px;
    }
}
</style>
